import { Controller } from '@hotwired/stimulus'
import { RailsFetcher } from 'api/rails_fetcher'
import Routes from 'common/rails_routes'
import { Turbo } from '@hotwired/turbo-rails'
const modifyLinkNotToPropagateEventsToParent = (elem) => {
  const originalHandler = elem.onclick
  elem.onclick = (e) => {
    if (e?.button !== 0) { return }
    e.stopPropagation()
    originalHandler?.apply(elem, [e])
  }
}
const updateLinkWrappers = (root) => {
  root.querySelectorAll('a').forEach((elem) => {
    modifyLinkNotToPropagateEventsToParent(elem)
  })
  root.querySelectorAll('span.favorite-meats__count').forEach((elem) => {
    modifyLinkNotToPropagateEventsToParent(elem)
  })
}
class DailyReportsIndex extends Controller {
  connect () {
    const watchRoot = document.querySelector('.daily_reports')
    updateLinkWrappers(watchRoot)
    // meat_gazerのようにコントローラーがロードされた後で追加されるaタグについても
    // onclick handlerを上書きするためにMutationObserverを利用している。
    this.observer = new MutationObserver(() => {
      updateLinkWrappers(watchRoot)
    })
    this.observer.observe(watchRoot, { childList: true, subtree: true })
  }

  disconnect () {
    this.observer.disconnect()
  }

  visit (event) {
    // 肉ボタンなどカード内の操作をTurboやdocumentのクリック処理に届けるため、伝播は止めずにここで除外する
    if (event.target.closest('a, button, form')) { return }
    Turbo.visit(this.urlValue)
  }

  delete (e) {
    e.preventDefault()
    e.stopPropagation()
    if (!confirm('削除しますか？')) {
      return
    }
    const target = e.currentTarget
    const url = target.dataset.url
    if (url === undefined) {
      throw new Error('No URL found')
    }
    RailsFetcher.call({
      url,
      method: 'DELETE'
    }).then((response) => {
      if (response.ok) {
        Turbo.visit(Routes.daily_reports_path(), { action: 'replace' })
      } else {
        // TODO: ユーザーに分かるようにエラーメッセージ出したい
        console.debug('Unexpected status: ' + response.statusText)
      }
    })
  }
}
DailyReportsIndex.values = { url: String }
export default DailyReportsIndex
